import { Post } from "../Request/Api";

export default {
  state: {
    flag: localStorage.getItem("Flag"),
    countries: [
      {
        code: "en|en",
        title: "English",
      },
      {
        code: "en|es",
        title: "Spanish",
      },
      {
        code: "en|pt",
        title: "Portuguese",
      },
      {
        code: "en|de",
        title: "German",
      },
      {
        code: "en|cs",
        title: "Czech",
      },
      {
        code: "en|ja",
        title: "Japanese",
      },
      {
        code: "en|fr",
        title: "French",
      },
      {
        code: "en|no",
        title: "Norwegian",
      },
    ],
  },
  getters: {
    getCountries(state: any) {
      return state.countries;
    },
    getFlag(state: any) {
      return state.flag;
    },
  },
  actions: {
    changeLanguage({ commit }: any, payload: object) {
      commit("SetLang", payload);
    },
  },
  mutations: {
    SetLang(state: any, payload: any) {
      state.flag = payload[0].title;
      localStorage.setItem("Flag", payload[0].title);
      // if (payload[0].title == "German") {
      //   state.flag = true;
      //   localStorage.setItem("Flag", "true");
      // } else {
      //   state.flag = false;
      //   localStorage.setItem("Flag", "false");
      // }
      state.countries = payload;
    },
  },
};
